import React from 'react';

function PeriodSelector({ period, onPeriodChange }) {
  const periods = [
    { value: '7days', label: '7日' },
    { value: '30days', label: '30日' },
    { value: '90days', label: '90日' },
    { value: 'all', label: '全期間' },
  ];

  return (
    <div className="flex gap-1">
      {periods.map((p) => (
        <button
          key={p.value}
          onClick={() => onPeriodChange(p.value)}
          className={`px-2 py-1 rounded transition-colors text-xs ${
            period === p.value
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}

export default PeriodSelector;
